/* eslint-disable import/no-anonymous-default-export */
export default {
  "error.message.user_does_not_exist": "El usuario no existe",
  "error.message.username_not_found": "Correo electrónico no encontrado",
  "error.message.wrong_password": "Contraseña incorrecta",
  "error.message.user_inactive": "Usuario inactivo",
  "error.message.missing_params": "Parámetros inválidos, ¡verifica!",
  "error.message.user_trial_time_expired":
    "El tiempo de evaluación del usuario ha expirado",
  "error.message.integration_already_exists":
    "Ya existe una integración entre estos proyectos",
  "error.message.integration_project_from_the_same_company":
    "Integración de proyectos de la misma empresa",
  "error.message.project_already_exists":
    "Ya existe un proyecto con ese nombre",
  "error.message.projectTemplate_already_exists":
    "Ya existe un modelo de proyecto con ese nombre",
  "error.message.speciality_already_exists":
    "Ya existe una especialidad con ese nombre",
  "error.message.tenant_trial_time_expired":
    "El tiempo de evaluación de la empresa ha expirado",
  "error.message.download_not_available": "Descarga no disponible",
  "error.message.folder_not_created":
    "Ocurrió un error en la creación de la carpeta",
  "error.message.error_on_upload": "Error al cargar archivo",
  "error.message.folder_already_exists": "Esta carpeta ya existe",
  "error.message.folder_not_found": "Carpeta no encontrada",
  "error.message.file_not_found": "Archivo no encontrado",
  "error.message.file_not_created":
    "Ocurrió un error en la creación del archivo",
  "error.message.error": "Ocurrió algún error",
  "error.message.file_already_exists": "Este archivo ya existe",
  "error.message.entity_already_saved": "La entidad ya posee acceso",
  "error.message.invalid_current_password": "Contraseña actual inválida",
  "error.status.400": "Solicitud inválida",
  "error.status.401": "No autorizado",
  "error.status.403": "Prohibido",
  "error.status.404": "No encontrado",
  "error.status.500": "Error interno del servidor",
  "error.status.502": "Falla de comunicación con el servidor",
  "error.status.503": "Servicio no disponible",
  "error.status.504": "La comunicación con el servidor ha expirado",
};
